import config from '@/config/appConfig';
//import router from '@/router';
import { userManager } from '../router'
import { useAuthStore } from '@/store/auth';
import { useLoadingStore } from '@/store/loading';
import i18n from '@/plugins/i18n';
import axios from 'axios';

const instance = axios.create({
  baseURL: process.env.VUE_APP_DEVPROD === 'DEV' ? config.apiBaseUrlDev : config.apiBaseUrl,
  withCredentials: true,
  headers: {
    accept: 'application/json'
  },
  // Axios defaults to `key[]=value` for array query params, which
  // ASP.NET Core's default model binding does not bind for `int[]?`
  // parameters (it silently comes through as null). `indexes: null`
  // switches to the repeated-key form (`key=value1&key=value2`), which
  // ASP.NET Core does bind reliably.
  paramsSerializer: { indexes: null }
});

instance.interceptors.request.use(
  function (config) {
    const authStore = useAuthStore();
    const token = authStore.accessToken;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Map UI locale codes to ISO 639-1 language codes
    const localeMap = { 'UA': 'uk', 'EN': 'en' };
    config.headers['Accept-Language'] = localeMap[i18n.global.locale.value] || 'uk';

    useLoadingStore().start();
    return config;
  },
  function (error) {
    useLoadingStore().finish();
    return Promise.reject(error);
  }
);

/*instance.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;
    const authStore = useAuthStore();

    if (error.response?.status === 401) {
      authStore.clearUser();
      router.push('/');
    }
    return Promise.reject(error);
  }
);*/
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error)
        } else {
            prom.resolve(token)
        }
    })
    failedQueue = []
};

// --- Response interceptor (логіка refresh)
instance.interceptors.response.use(
  response => {
    useLoadingStore().finish();
    return response;
  },
  async error => {
    const originalRequest = error.config;
    useLoadingStore().finish();

    if (!error.response || error.response.status !== 401) {
      return Promise.reject(error)
    }

    if (originalRequest._retry) {
      return Promise.reject(error)
    }

    originalRequest._retry = true

    // якщо refresh вже виконується → ставимо в чергу
    if (isRefreshing) {
      return new Promise((resolve, reject) => {
        failedQueue.push({
          resolve: token => {
            originalRequest.headers = originalRequest.headers || {}
            originalRequest.headers["Authorization"] = "Bearer " + token
            resolve(instance(originalRequest))
          },
          reject: err => reject(err)
        })
      })
    }

    isRefreshing = true

    try {
        const user = await userManager.signinSilent()
        const authStore = useAuthStore();
        console.log("new user:", user)
        authStore.setUser(user);

        const newToken = user.access_token

        // оновлюємо заголовок оригінального запиту
        originalRequest.headers = originalRequest.headers || {}
        originalRequest.headers["Authorization"] = "Bearer " + newToken

        processQueue(null, newToken)

        // retry запиту
        return await instance(originalRequest)

    } catch (err) {
      processQueue(err, null)

      // якщо silent refresh впав — редірект
      await userManager.signinRedirect()

      return Promise.reject(err)

    } finally {
      isRefreshing = false
    }
  }
)

export default instance;